// extracted by mini-css-extract-plugin
export var quillEditor = "_j4-1";
export var variable = "_j4-0";